<template>
  <div v-if="contact" class="mt-6">
    <div v-if="scorecard">
      <div class="">
        <label class="mt-4 block text-sm leading-5 font-medium text-gray-700">Notes</label>
        <div class="shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md">
          {{ scorecard.notes }}
        </div>

        <label class="mt-12 block text-sm leading-5 font-medium text-gray-700">
          Which stage should this candidate move to?
        </label>
        <div class="shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md">
          {{ scorecard.next_stage }}
        </div>
        <span class="block mt-12 font-medium text-gray-500"
          >Scorecard submitted {{ fromNow(scorecard.created_at) }} ago by {{ scorecard.user.email }}</span
        >
      </div>
    </div>
    <div v-else>
      <TextAreaInput
        label="Notes"
        :model-value="interviewNotes"
        rows="8"
        :placeholder="placeholderContent"
        @update:model-value="interviewNotes = $event"
      />

      <div class="mt-8"></div>
      <SelectMenu
        label="Which stage should this candidate move to?"
        :initial-value="nextStage"
        :options="['Interview', 'Onboarding', 'Hired', 'Disqualified', 'Nurture']"
        @selected-option="handleSelectedOption"
      />

      <CheckboxInput
        v-if="showContactDisqualify"
        class="mt-4"
        description="Send automated rejection email"
        :model-value="sendRejectionEmail"
        @update:model-value="sendRejectionEmail = $event"
      />
      <FormKit
        v-if="showOnboardingChecklist"
        v-model="selectedChecklist"
        type="select"
        label="Onboarding Checklist"
        :options="onboardingChecklists"
        placeholder="Select an onboarding checklist"
        label-class="block text-sm leading-5 font-medium text-gray-700"
        class="mt-8 w-full"
        input-class="w-full !max-w-none"
        help="Are you sure you want to onboard this candidate? Onboarding will send them an email to begin the process of joining your brokerage/team."
        help-class="mt-1 text-sm text-gray-600"
      />
    </div>

    <div class="mt-12">
      <button
        class="inline-block mt-4 px-3 py-2 rounded bg-[#fde68a] font-semibold text-sm text-slate-800"
        :class="{ 'opacity-30 cursor-not-allowed': !validScorecard }"
        :disabled="!validScorecard"
        @click="submitScorecard"
      >
        Submit scorecard
      </button>
    </div>
  </div>
</template>

<script>
import TextAreaInput from '../../components/shared/TextAreaInput.vue';
import SelectMenu from '../shared/SelectMenu.vue';
import CheckboxInput from '../shared/CheckboxInput.vue';
import DateUtility from '../../utilities/dates';

export default {
  components: {
    TextAreaInput,
    SelectMenu,
    CheckboxInput,
  },
  data() {
    return {
      showContactDisqualify: false,
      sendRejectionEmail: false,
      showOnboardingChecklist: false,
      selectedChecklist: null,
      onboardingChecklists: [],
      selectedNextStage: null,
      selectedTab: 'Scorecard',
      interviewNotes: '',
      contactEvent: null,
      contact: null,
      scorecard: null,
    };
  },
  computed: {
    nextStage() {
      if (this.contact.stage === 'Phone Screen') {
        return 'Interview';
      } else if (this.contact.stage === 'Interview') {
        return 'Onboarding';
      } else {
        return 'Nurture';
      }
    },
    validScorecard() {
      if (this.selectedNextStage === 'Onboarding') {
        return this.selectedChecklist !== null && this.interviewNotes !== '';
      } else {
        return this.selectedNextStage !== null && this.interviewNotes !== '';
      }
    },
    placeholderContent() {
      return `ex: Spoke with ${this.contact.name}, they have been an agent for 3 years and has done a total of 15 transactions. Their license is currently with ABC Realty, but feels like they're not really getting a whole lot of value from them. Great conversation, they're coming in next week for a face to face interview!`;
    },
  },
  async mounted() {
    const res = await fetch(`/api/contact_events/${this.$route.params.id}`);
    const { contact, scorecard, ...contactEvent } = await res.json();

    await this.fetchOnboardingChecklists();

    this.contactEvent = contactEvent;
    this.contact = contact;
    this.scorecard = scorecard;
  },
  methods: {
    ...DateUtility,
    handleSelectedTab(tab) {
      this.selectedTab = tab;
    },
    async reload() {
      await this.$router.go();
    },
    handleSelectedOption(nextStage) {
      this.selectedNextStage = nextStage;
      if (nextStage === 'Disqualified') {
        this.showContactDisqualify = true;
      } else if (nextStage === 'Onboarding') {
        this.showOnboardingChecklist = true;
      } else {
        this.showContactDisqualify = false;
        this.sendRejectionEmail = false;
      }
    },
    async submitScorecard() {
      const res = await fetch(`/api/contact_events/${this.$route.params.id}/scorecard`, {
        method: 'POST',
        body: JSON.stringify({
          scorecard: {
            notes: this.interviewNotes,
            next_stage: this.selectedNextStage,
            send_rejection_email: this.sendRejectionEmail,
            task_checklist_id: this.selectedChecklist,
          },
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });

      const { record } = await res.json();
      const { contact, ...scorecard } = record;

      this.$emit('update-contact', contact);

      this.scorecard = scorecard;
    },
    async fetchOnboardingChecklists() {
      const res = await fetch('/api/task_checklists?checklist_type=onboarding');
      const { records } = await res.json();

      this.onboardingChecklists = records.map(({ id, name }) => {
        return { value: id, label: name };
      });
    },
  },
};
</script>

<style scoped>
.formulate-input-element.formulate-input-element--select select {
  @apply !max-w-none w-full;
}
</style>
